<template lang="pug">
.detail.scrollable.h-100
  .mx-4.my-2.px-3.pt-3
    .d-flex
      .d-flex.text-large.mr-4
        | รายการขายเลขที่
        FormattedEntryNo.ml-2(
          :entryNo='sellRecord.entryNo'
          :orderId='sellRecord.id'
        )
      .text-large.mr-4
        | {{ formattedDate }}
        | เวลา {{ formattedTime }}
      CustomStatusBadge(
        :status='sellRecord.status'
        type='ORDER_STATUS'
      )
      template(
        v-if='[`submitted`, `cancelled`].includes(sellRecord.apiStatus) === false'
      )
        button.btn.btn-secondary.ml-auto(@click='editOrder')
          | แก้ไขรายการ

    .d-flex.align-items-start.mt-2.pt-4.pb-3
      CSCustomerCompactDetailHeader(:data='customer')
      div.ml-auto.mr-4
        .d-flex
          div
            //- p {{customer}}
            .d-flex
              .text-large.mr-3
                | จัดส่งหน้าร้าน
              CustomStatusBadge(
                :status='sellRecord.shipmentStatus'
                type='SHIPMENT_STATUS'
              )

            .text-small
              | เลขที่ใบสั่งซื้อจากลูกค้า
              | {{ sellRecord.customer_po_no ? sellRecord.customer_po_no : '-' }}

            .text-small.text-danger(v-if="sellRecord.warehouse_id !== null")
              | เปลี่ยนคลังเป็น {{warehouseName}}

          div.ml-4.pl-2
            .text-small ผู้ทำรายการขาย
            .text-medium.text-bold
              template(v-if='sellRecord && sellRecord.user')
                | {{ sellRecord.user.name }}
              template(v-else) -

        CSCustomerBasicStat.mt-4.pt-2(:data='customer')

  CSCustomerExtendedStat(
    v-if="!([`submitted`, `cancelled`].includes(sellRecord.apiStatus))"
    :data='customer'
    :grade='customer.grade'
    :order='{total: total}'
  )

  .d-flex.px-4.py-2
    .text-large รายการสินค้า
    LoadingIndicator.ml-2(v-if='isLoading')
  hr.m-0

  template(v-if='sellRecord')
    .px-4.pt-2
      //- div {{ JSON.stringify(sellRecord) }}
      CustomTable(
        :columns='tableColumns'
        :data='tableData'
        :itemClickable='false'
      )
    hr.m-0
    .d-flex.justify-content-between.mx-3.px-4.py-4
      .d-flex
        div หมายเหตุ:
        template(v-if='sellRecord.remarks || sellRecord.internal_message')
          ol
            li(v-if='sellRecord.remarks')
              | {{ sellRecord.remarks }}
            li(v-if='sellRecord.internal_message')
              | {{ sellRecord.internal_message }}
        template(v-else)
          .ml-4 -
      .d-flex.flex-column.align-items-end
        .text-xlarge
          span.mr-3 รวมค่าสินค้าทั้งสิ้น
          span.ml-4 {{ total | currency }}
        //- .text-xlarge
        //-   span.mr-3 รวมค่าคอมมิชชั่นที่ได้รับ
        //-   span.ml-4 {{ (1320.00) | currency }}

    template(v-if='sellRecord.status === $api.customer.ORDER_STATUS.PENDING')
      .dialog-button-bar.d-flex.justify-content-center.py-4
        div.text-info.h5.m-0.font-weight-normal(v-if="sellRecord.apiStatus === 'pending_admin'")
          | ออเดอร์นี้กำลังรอผู้ตรวจสอบออเดอร์/แอดมินตรวจสอบ
        template(v-else)
          template(v-if="isConditionPassed")
            button.btn.btn-upa-warning(@click='rejectSell')
              | ไม่อนุมัติรายการขาย
            button.btn.btn-upa-success.ml-3(@click='approveSell')
              | อนุมัติรายการขาย
          template(v-else)
            p.m-0.d-flex.align-items-center: small.text-secondary
              | อนุมัติ/ไม่อนุมัติไม่ได้เนื่องจากไม่ผ่านเงื่อนไขสำคัญ
          button.btn.ml-3(
            @click='passToAdmin' :class="(isConditionPassed) ? 'btn-secondary' : 'btn-primary'")
            | ส่งต่อแอดมิน

    Modal(
      name='action-to-back-order'
      width='540px' height='480px'
      transition='modal-transition'
      :clickToClose='true'
    )
      .p-4
        p.h4.text-center.text-danger อนุมัติไม่สำเร็จ
        p.h6.text-center.text-danger เนื่องจากมีสินค้าที่ไม่พอในรายการ
        CustomTable(
          :columns='failedApprovalItemsColumns'
          :data='failedApprovalItems'
          :itemClickable='false'
        )
        .dialog-button-bar.d-flex.justify-content-center.py-4
          div
            button.btn.ml-3.btn-secondary(
              @click="$modal.hide('action-to-back-order')")
              | กลับไปแก้ไข
          div(v-if="failedApprovalItems.filter((e) => e.remaining === 0).length === 0")
            button.btn.btn-upa-warning.ml-3(@click='approveSellForce')
              | เปิดเท่าที่มี
            br
            p.mt-2: small ส่วนที่ขาดจะปัดเป็น back order
          div.px-4.text-center(v-else): small
            | มีรายการที่เหลือ 0 หน่วย
            br
            | จำเป็นต้องกลับไปแก้ไขในออเดอร์

    Modal(
      name='action-status'
      width='480px' height='480px'
      transition='modal-transition'
      :clickToClose='false'
    )
      StatusDialog(
        :type='actionStatusType'
        @closeButtonClicked='hideStatusDialog'
      )

</template>

<script>
import CSCustomerCompactDetailHeader from '@/components/_cs/customers/CSCustomerCompactDetailHeader.vue';
import CSCustomerBasicStat from '@/components/_cs/customers/CSCustomerBasicStat.vue';
import CSCustomerExtendedStat from '@/components/_cs/customers/CSCustomerExtendedStat.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    sellRecord: {
      default: () => ({}),
    },
  },
  computed: {
    formattedDate() {
      return this.$moment(this.sellRecord.date).format('D MMMM YYYY');
    },
    formattedTime() {
      return this.$moment(this.sellRecord.time).format('HH:mm');
    },
    warehouseName() {
      const list = this.availableWarehouse.filter((elm) => {
        if (elm.value && this.sellRecord.warehouse.toString() === elm.value.toString()) return true;
        return false;
      });
      if (list.length > 0) return list[0].text;
      return '';
    },
  },
  watch: {
    sellRecord() {
      this.sellRecordUpdated();
    },
  },
  async mounted() {
    this.sellRecordUpdated();
    const wareHouseRes = await this.$api.order.availableWarehouse();
    if (wareHouseRes.status === 200) {
      this.availableWarehouse = wareHouseRes.data;
    }

    const resCondition = await this.$api.order.actions.approveConditionCheck(
      this.sellRecord.id,
    );
    this.isConditionPassed = resCondition.data.canApprove;
  },
  data: () => ({
    availableWarehouse: [],
    isConditionPassed: false,
    failedApprovalItems: [],
    failedApprovalItemsColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.item.product_id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.item.product.name;
        },
      },
      requested: {
        title: 'พยายามสั่ง',
        align: 'right',
      },
      remaining: {
        title: 'มีเหลือ',
        align: 'right',
        computed(row) {
          return `<span class="text-danger">${row.remaining}</span>`;
        },
      },
    },
    tableColumns: {
      productId: {
        title: 'รหัสสินค้า',
        computed(row) {
          return row.product.id;
        },
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
        computed(row) {
          return row.product.name;
        },
      },
      percentage: {
        title: '% GP AVG Cost',
        align: 'right',
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      productPrice: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed(row) {
          return Number(row.price) / Number(row.amount);
        },
      },
      totalPrice: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed(row) {
          return row.price;
        },
      },
    },
    tableData: {},
    actionStatusType: '',
    isLoading: false,

    customerStat: {},
    total: 0,
    totalCommission: 0,

  }),
  // mounted() {
  //   this.loadData();
  // },
  methods: {
    // async loadData() {
    //   this.isLoading = true;

    //   const res = await this.$api.order.getWithId(this.orderId);
    //   if (res.status === 200) {
    //     this.sellRecord = res.data.data;
    //   }

    //   this.isLoading = false;
    // },

    async rejectSell() {
      try {
        // send request to the API
        const res = await this.$api.order.actions.reject(this.sellRecord.id);

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'cs.sellrecord.reject';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    async approveSellForce() {
      try {
        const res = await this.$api.order.actions.approve(this.sellRecord.id, true);

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'cs.sellrecord.approveforce';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    async approveSell() {
      try {
        const res = await this.$api.order.actions.approve(this.sellRecord.id);
        // alert(JSON.stringify(res));

        if (!res.data.success) {
          this.$modal.show('action-to-back-order');
          this.failedApprovalItems = res.data.items;
        }

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'cs.sellrecord.approve';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },
    async passToAdmin() {
      try {
        const res = await this.$api.order.actions.forward(this.sellRecord.id);
        // alert(JSON.stringify(res));

        // if success..
        if (res.status === 201) {
          this.$modal.show('action-status');
          this.actionStatusType = 'cs.sellrecord.admin';
        }
      } catch (e) {
        alert(`เกิดข้อผิดพลาด.. \n${e.message}`);
      }
    },

    editOrder() {
      this.$router.push({
        name: 'cs.new-order', // can't use path, cause it WON'T allow passing hidden params
        params: {
          ...this.sellRecord, // pass eveything inside the order

          editingOrderId: this.sellRecord.id,
          // isEditingOrder: true,
        },
      });
    },

    hideStatusDialog() {
      this.$modal.hide('action-status');
      this.$emit('closeButtonClicked');
    },

    sellRecordUpdated() {
      this.loadCustomerStat();

      this.tableData = this.sellRecord.products ? this.sellRecord.products : [];

      let total = 0;
      // let totalCommission = 0;
      for (let i = 0; i < this.sellRecord.products.length; i += 1) {
        const PROD = this.sellRecord.products[i];
        total += (Number(PROD.price));
        // totalCommission += (Number(PROD.commission));
      }

      this.total = total;
    },

    async loadCustomerStat() { // FIXME: looks like a deprecated method
      try {
        const res = await this.$api.customer.statForCustomerWithId(this.sellRecord.customer_id);
        this.customerStat = res.data.data;
      } catch (e) {
        console.warn(e);
      }
    },
  },
  components: {
    CSCustomerCompactDetailHeader,
    CSCustomerBasicStat,
    CSCustomerExtendedStat,
  },
};
</script>

<style lang="scss">
// .detail {}
</style>
